export const headCellAccesoryProductInSite = [
  { id: "id", disablePadding: false, label: "Id" },
  { id: "barCode", disablePadding: false, label: "Código de barras" },
  { id: "subcategory", disablePadding: false, label: "Subcategoría" },
  { id: "price", disablePadding: false, label: "Precio" },
  { id: "discount", disablePadding: false, label: "Descuento" },
  { id: "provider", disablePadding: false, label: "Proveedor" },
  { id: "available", disablePadding: false, label: "Agregar a carrito" },
];
